import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BundlesSection from '../components/BundlesSection';
import PromoBanner from '../components/PromoBanner';
import SEO from '../components/SEO';
import { seoData } from '../data/seoData';

const BundlesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.bundles} />
      <PromoBanner />
      <Navigation />
      
      {/* Course Bundles */}
      <BundlesSection />
      
      <Footer />
    </div>
  );
};

export default BundlesPage;